import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  doEmployeesRequest,
  doGetEmployeeByIdRequest,
} from '../../containers/Employees/service';

export const doGetEmployees = createAsyncThunk(
  'employee/doGetEmployees',
  async (payload, { rejectWithValue }) => {
    try {
      const { metaData } = payload;
      const response = await doEmployeesRequest(metaData);
      return response;
    } catch (err) {
      console.log('doGetEmployees error: ', err);
      return rejectWithValue([], err);
    }
  }
);

export const doGetEmployeeById = createAsyncThunk(
  'employee/doGetEmployeeById',
  async (payload, { rejectWithValue }) => {
    try {
      const { id } = payload;
      const response = await doGetEmployeeByIdRequest(id);
      return response;
    } catch (err) {
      console.log('doGetEmployeeById error: ', err);
      return rejectWithValue([], err);
    }
  }
);

export const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    loading: false,
    error: null,
    grids: [
      {
        id: 'active',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'inactive',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
    ],
    // totalRecords: 0,
    gridTabs: [],
    activeTabIndex: null,
    lastCreatedEmployeeId: null,
    employeeDidRelieved: null,
    employeeDidRejoined: null,
  },
  reducers: {
    updateTableMetaData: (state, { payload }) => {
      state.metaData = payload.metaData;
    },
    updateGridMetaData: (state, { payload: { metaData, gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData = {
        ...state.grids[gridIndex].metaData,
        ...metaData,
      };
    },
    resetFilters: (state) => {
      state.metaData = {
        ...state.metaData,
        filters: [],
      };
    },
    resetGridFilters: (state, { payload: { gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.filters = [];
    },
    addOrGotoEmployeeTab: (state, { payload }) => {
      const { tab: newTab = {} } = payload;
      const tabFound = state.gridTabs.find((tab) => tab.key === newTab.key);

      if (!tabFound) {
        state.gridTabs = state.gridTabs.concat(newTab);
        state.activeTabIndex = newTab.key;
      } else {
        state.activeTabIndex = newTab.key;
      }
    },
    gotoEmployeeTab: (state, { payload }) => {
      const { key } = payload;
      state.activeTabIndex = key;
    },
    removeEmployeeTab: (state, { payload }) => {
      const { key } = payload;
      const foundIndex = state.gridTabs.findIndex((tab) => tab.key === key);
      if (foundIndex >= 0) {
        state.gridTabs = state.gridTabs.filter((tab) => tab.key !== key);
        state.activeTabIndex = 'active-list';
      }
    },
    addNewEmployeeTab: (state, { payload }) => {
      const { tab: newTab = {} } = payload;
      console.log('%%%%%%%%%%%%% addNewEmployeeTab', newTab);
      state.gridTabs = state.gridTabs.concat(newTab);
      state.activeTabIndex = newTab.key;
    },
    newEmployeeAdded: (state, { payload: { employee } }) => {
      state.lastCreatedEmployeeId = employee.id;
    },
    employeeRelieved: (state, { payload: { employee } }) => {
      state.employeeDidRelieved = employee.id;
    },
    employeeRejoined: (state, { payload: { employee } }) => {
      state.employeeDidRejoined = employee.id;
    },
    updateVisibleColumns: (state, { payload: { gridId, visibleColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.visibleColumns = visibleColumns;
      state.grids[gridIndex].metaData.exportColumns = visibleColumns;
    },
    updateExportColumns: (state, { payload: { gridId, exportColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.exportColumns = exportColumns;
    },
    updateGridTabTitle: (state, { payload }) => {
      const { key, title } = payload;
      const tabFound = state.gridTabs.find((tab) => tab.key === key);
      if (tabFound) {
        tabFound.title = title;
      }
    },
  },
  extraReducers: {
    [doGetEmployees.fulfilled]: (state, { meta, payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.totalRecords = payload.totalRecords;
    },
    [doGetEmployees.pending]: (state, { meta }) => {
      state.loading = true;
      state.error = null;
    },
    [doGetEmployees.rejected]: (state, { meta, payload, error }) => {
      state.loading = false;
      state.error = 'Loading employees failed';
    },
    [doGetEmployeeById.fulfilled]: (state, { meta, payload }) => {
      state.loading = false;
      console.log(
        '===============',
        state.gridTabs.filter((i) => i.key === payload.data.empId)
      );
      state.gridTabs = state.gridTabs.map((tab) => {
        return {
          ...tab,
          data: payload.data,
        };
      });
    },
    [doGetEmployeeById.pending]: (state, { meta }) => {
      state.loading = true;
      state.error = null;
    },
    [doGetEmployeeById.rejected]: (state, { meta, payload, error }) => {
      state.loading = false;
      state.error = 'Loading employee by ID failed';
    },
  },
});

export const {
  updateTableMetaData,
  updateGridMetaData,
  resetFilters,
  resetGridFilters,
  addOrGotoEmployeeTab,
  updateGridTabTitle,
  gotoEmployeeTab,
  removeEmployeeTab,
  addNewEmployeeTab,
  newEmployeeAdded,
  updateVisibleColumns,
  updateExportColumns,
  employeeRelieved,
  employeeRejoined,
} = employeeSlice.actions;

export default employeeSlice.reducer;
